// OcipError.jsx  (DIK Bit-map)
import "./OcipError.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Table } from "react-bootstrap";
import { getIvFieldValue } from "../../utils/ivErrorDataUtils";

/* 1) DIK 비트맵 정의 (표 기준) */
const AlarmModalData = {
  1: { // STATUS_1 ← State
    title: "STATUS_1 (State)",
    rows: [
      { bit: "Bit0", desc: "SqStart", code: "0x01" },
      { bit: "Bit1", desc: "SqDone",  code: "0x02" },
      { bit: "Bit2", desc: "FreqOk",  code: "0x04" },
      { bit: "Bit3", desc: "VpvOk",   code: "0x08" },
      { bit: "Bit4", desc: "VdcOk",   code: "0x10" },
      { bit: "Bit5", desc: "VsOk",    code: "0x20" },
      { bit: "Bit6", desc: "McOn",    code: "0x40" },
      { bit: "Bit7", desc: "FanOn",   code: "0x80" },
      { bit: "Bit8", desc: "",        code: "" },
    ],
  },
  3: { // FAULT_1 ← Error[0]
    title: "FAULT_1 (Error[0])",
    rows: [
      { bit: "Bit0", desc: "VpvLvF", code: "0x01" },
      { bit: "Bit1", desc: "VpvOvF", code: "0x02" },
      { bit: "Bit2", desc: "VdcLvF", code: "0x04" },
      { bit: "Bit3", desc: "VdcOvF", code: "0x08" },
      { bit: "Bit4", desc: "VsLvF",  code: "0x10" },
      { bit: "Bit5", desc: "VsOvF",  code: "0x20" },
      { bit: "Bit6", desc: "CALErr", code: "0x40" },
      { bit: "Bit7", desc: "SETErr", code: "0x80" },
      { bit: "Bit8", desc: "CMDErr", code: "0x100" },
    ],
  },
  4: { // FAULT_2 ← Error[1]
    title: "FAULT_2 (Error[1])",
    rows: [
      { bit: "Bit0", desc: "IdcOcHw", code: "0x01" },
      { bit: "Bit1", desc: "AcOcHw",  code: "0x02" },
      { bit: "Bit2", desc: "AcSYNC",  code: "0x04" },
      { bit: "Bit3", desc: "InvF",    code: "0x08" },
    ],
  },
};

const DikError = ({ SelInverter }) => {
  const ivData  = useSelector((state) => state.ivData  || {});
  const [openModalNum, setOpenModalNum] = useState(null);
  const closeModal = () => setOpenModalNum(null);

  // DIK 각 그룹의 원시 값 가져오기 (백엔드 필드명 사용)
  const getDikValue = (num) => {
    switch (num) {
      case 1: return getIvFieldValue(ivData, "state", SelInverter);            // STATUS_1
      case 2: return getIvFieldValue(ivData, "Pfault", SelInverter);           // STATUS_2
      case 3: return getIvFieldValue(ivData, "fault0", SelInverter);           // FAULT_1
      case 4: return getIvFieldValue(ivData, "fault1", SelInverter);           // FAULT_2
      case 5: return getIvFieldValue(ivData, "fault3", SelInverter);           // FAULT_3
      default: return 0;
    }
  };

  // 16비트 플래그 파싱
  const parseBitFlags = (value) => {
    const n = Number(value) || 0;
    const flags = {};
    for (let i = 0; i <= 15; i++) flags[`Bit${i}`] = ((n >> i) & 1) === 1;
    return flags;
  };

  // 이상 판정: FAULT 계열만 값 != 0 이면 비정상
  const isAbnormal = (num, value) => {
    if (typeof value !== "number") return false;
    if (num >= 3) return value !== 0; // FAULT_1~3
    return false;                     // STATUS_1~2는 표시만
  };

  // 모달 렌더
  const renderModalContent = () => {
    const modal = AlarmModalData[openModalNum];
    if (!modal) return null;

    const rawValue = getDikValue(openModalNum);
    const activeBits = parseBitFlags(rawValue);

    return (
      <>
        <Modal.Header closeButton>
          <Modal.Title>
            {modal.title} {typeof rawValue === "number" ? `(0x${rawValue.toString(16).toUpperCase()})` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = activeBits[row.bit.trim()];
                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                    <td>{row.code}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>닫기</Button>
        </Modal.Footer>
      </>
    );
  };

  // 화면 목록 (각 항목 클릭 → 해당 그룹 모달)
  const items = [
    { label: "STATUS_1 (State)",   num: 1 },
    { label: "STATUS_2 (Run)",     num: 2 },
    { label: "FAULT_1 (Error[0])", num: 3 },
    { label: "FAULT_2 (Error[1])", num: 4 },
    { label: "FAULT_3 (Error[2])", num: 5 },
  ];

  return (
    <div className="status-list-container">
      <div className="status-list">
        {items.map(({ label, num }) => {
          const value = getDikValue(num);
          const abnormal = isAbnormal(num, value);
          return (
            <div key={num} className="status-item">
              <span className="status-value">
                {label}: {value ?? "-"}
              </span>
              <button onClick={() => setOpenModalNum(num)}>
                <span className={abnormal ? "blinking-icon" : ""}>
                  {abnormal ? "🔴" : "🟢"}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {openModalNum !== null && (
        <Modal show onHide={closeModal} size="lg">
          {renderModalContent()}
        </Modal>
      )}
    </div>
  );
};

export default DikError;
